import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-splash-screen-dialog',
  templateUrl: './loading-splash-screen-dialog.component.html',
  styleUrls: ['./loading-splash-screen-dialog.component.scss'],
})
export class LoadingSplashScreenDialogComponent {}
